import { useContext } from "react";
import CheckIcon from 'assets/Check.png';
import MoneyIcon from 'assets/cash.png';
import UncheckIcon from 'assets/UnCheck.png';
import { TOContext } from "context/TContext";
import {
	Box,
	FormControl,
	FormControlLabel,
	Radio,
	useTheme
} from "@mui/material";
import {
	FullModeInnerWrapper,
	FullModeWrapper,
	PaymentStyledInner,
	PaymentStyledRadioGroup,
	PaymentStyledText
} from "components/styles";


const PayCash = () => {
	const theme = useTheme();
	const { CASH, payWithCreditCard, handleSelect } = useContext(TOContext);

	const handleClick = () => {
		handleSelect(CASH);
		setTimeout(() => {
			const paymentElement = document.getElementById('cash-payment-button');
			if (paymentElement) {
				paymentElement.scrollIntoView({
					block: 'center'
				});

				// Add another scroll for mobile keyboards
				setTimeout(() => {
					paymentElement.scrollIntoView({
						block: 'center'
					});
				}, 300);
			}
		}, 50);
	};

	return (
		<FullModeWrapper
			onClick={handleClick}
			sx={{
				cursor: 'pointer',
				border: payWithCreditCard === CASH &&
				 `2px solid ${theme.palette.primary.main}`,
				mt: 2
			}}
		>
			<FullModeInnerWrapper>
				<FormControl sx={{ width: '100%' }}>
					<PaymentStyledRadioGroup
						aria-labelledby="cash-payment-option"
						name="radio-buttons-group"
						value={payWithCreditCard}
					>
						<FormControlLabel
							value={CASH}
							control={
								<Radio
									icon={<img src={UncheckIcon} alt="uncheck" />}
									checkedIcon={<img src={CheckIcon} alt="checked" />}
								/>
							}
							label={
								<PaymentStyledInner>
									<Box
										component="img"
										src={MoneyIcon}
										alt="cash"
										sx={{
											width: 24,
											height: 24,
											display: 'block',
											objectFit: 'contain'
										}}
									/>
									<PaymentStyledText>Pay by Cash</PaymentStyledText>
								</PaymentStyledInner>
							}
							sx={{
								width: '100%',
								margin: 0,
								'& .MuiFormControlLabel-label': {
									fontWeight: 700,
									width: '100%',
									display: 'flex',
									justifyContent: 'center',
								},
								'& .MuiButtonBase-root': { pr: 0 }
							}}
						/>
					</PaymentStyledRadioGroup>
				</FormControl>
			</FullModeInnerWrapper>
		</FullModeWrapper>
	)
};

export default PayCash;
